<template>
  <CContainer fluid class="heads">
    <!-- <CHeader position="sticky" class="" style="background-color: #98cff4"> -->
    <div class="row py-3">
      <div class="col-md-4 col-lg-4 col-xs-12 col-sm-12">
        <div class="d-flex align-items-center">
          <div class="d-flex align-items-center mr-3">
            <CIcon class="px-1" icon="cil-menu" size="xxl" @click="$store.commit('toggleSidebar')" />
          </div>
          <div class="d-flex align-items-center ml-3">
            <AppHeaderDropdownAccnt />
          </div>
        </div>
      </div>

      <div class="col-md-4 col-lg-4 col-xs-12 col-sm-12 py-1" style="
          font-weight: bolder !important;
          font-size: 25px;
          text-align: center !important;
          color: white;
        ">
        <span>
          {{ currRoutes }}
        </span>
      </div>
      <div class="col-md-4 col-lg-4 col-xs-12 col-sm-12 d-flex align-items-center justify-content-between">
        <div class="d-flex flex-column flex-sm-row justify-content-end col-md-6 col-lg-9 col-xs-12 col-sm-12">
          <select class="legality px-4" v-model="setLegalEntity" :disabled="userInf.AllowedToChangeLegalEntity == false ||
            currRoutes == 'NEW REQUEST' ||
            currRoutes == 'APPROVER VIEW'
            " style="
              background-color: #3085d6;
              color: white;
              border: none;
              border-radius: 5px;
              margin-top: 5px;;
              height: 40px;
              width: 158px;
              margin-right: 10px;
              cursor: pointer;
            " @change="updateLegalEntity(setLegalEntity)">
            <option v-for="entity in legalEntity" :value="entity.DataArea" :key="entity.DataArea" :title="entity.Name"
              style="cursor: pointer;">
              {{ entity.DataArea }}
            </option>
          </select>
        </div>
        <div>
          <CDropdownItem v-if="
            currRoutes == 'APPROVE PAYMENT' ||
            (currRoutes == 'REQUEST FOR PAYMENT' &&
              breadcrumbs != 'APPROVER VIEW')
          " @click="logout()"
            style="font-size: 20px; text-align: right; color: white; font-weight: bold; cursor: pointer;">
            <font-awesome-icon icon="fas fa-sign-out" style="font-size: 20px; margin-right: 5px;" />
            LOGOUT
          </CDropdownItem>
          <CDropdownItem @click="back()" v-if="
            currRoutes == 'NEW REQUEST' ||
            (currRoutes == 'REQUEST FOR PAYMENT' &&
              breadcrumbs == 'APPROVER VIEW') ||
            currRoutes == 'CONFIRMATION'
          " style="font-size: 20px; text-align: right; color: white; cursor: pointer;">
            <font-awesome-icon icon="fa fa-chevron-circle-left" style="font-size: 20px; margin-right: 5px" />
            <strong> BACK </strong>
          </CDropdownItem>
        </div>
      </div>
    </div>
    <!-- </CHeader> -->
  </CContainer>


</template>

<script>
// import AppBreadcrumb from './AppBreadcrumb'
import AppHeaderDropdownAccnt from './AppHeaderDropdownAccnt'
import { logo } from '@/assets/brand/logo'
// import { onMounted } from 'vue'
import axios from 'axios'
import router from '@/router'
// import { auth } from '@/views/modules/globalfunction';

export default {
  // beforeCreate() {
  //   auth();
  // },
  name: 'AppHeader',
  components: {
    // AppBreadcrumb,
    AppHeaderDropdownAccnt,
  },

  setup() {
    // console.log('USER INFO => ', userInf)
    let userInf = JSON.parse(localStorage.getItem('UserInfo'))

    return {
      logo,
      userInf,
      setLegalEntity: localStorage.getItem('legalEnt') !== null ? localStorage.getItem('legalEnt').toLocaleUpperCase() : localStorage.getItem('legalEnt'),
    }
  },
  data() {
    return {
      currRoutes: '',
      legalEntity: [],
      // selectedEntitiy: '',
      breadcrumbs: '',

    }
  },

  methods: {
    updateLegalEntity(Ent) {

      if (localStorage.getItem('legalEnt') != Ent) {
        localStorage.setItem('legalEnt', Ent)
        window.location.replace('/list-of-rfps/request-list')
      }
    },

    async getLegalEntity() {
      // const BearerToken = localStorage.getItem('BearerToken')
      let url = '/data/RAFIPayLegalEntity'
      let legalEntityReq = await axios.get(
        url,
        this.globalConfig,

      )

      this.legalEntity.push(...legalEntityReq.data.value)
      // console.log('legal Ent => ', this.legalEntity)
    },
    back() {
      // window.location.replace('/list-of-rfps/request-list')
      // window.history.back();
      let user = localStorage.getItem('uType');

      if (user == 'Approver') {
        window.location.replace('/list-of-rfps/approver-list')
      }
      else {
        window.location.replace('/list-of-rfps/request-list')
      }
    },
    getTitle() {
      this.breadcrumbs = ''
      let breadcrumbs2 = router.currentRoute.value.name
      this.currRoutes = breadcrumbs2

      if (breadcrumbs2 == 'NEW REQUEST' && this.$route.query.id) {
        this.currRoutes = 'NEW REQUEST'
      }
      if (breadcrumbs2 == 'APPROVER VIEW' && this.$route.query.id) {
        this.currRoutes = 'REQUEST FOR PAYMENT'
        this.breadcrumbs = 'APPROVER VIEW'
      }
      if (breadcrumbs2 == 'Confirmation') {
        this.currRoutes = 'CONFIRMATION'
      }

    },
    logout() {
      this.$router.push({ name: 'Login' })
    },
  },
  mounted() {
    this.getTitle()
    this.getLegalEntity()
  },
}
</script>
<style>
.legality:disabled {
  opacity: 0.5;
  /* Change this value as needed */
}

.heads {
  position: sticky;
  top: 0px;
  background-color: #98cff4;
  z-index: 1000;
}
</style>
